<template>
  <div>
    <section class="bg-white" id="productContentBGSection">
      <div class="col-lg-12 text-center height-5-rem bg-color-dynamic" :style="{
        textAlign: 'center',
        position: 'absolute',
        top: '-50px',        
        // backgroundColor: theme === 'dark' ? '#022534' : 'white'
      }">
        <div class="tab-wrapper">
            <nav class="height-5-rem" style="text-align: center;">
              <div class="nav nav-pills nav-justified height-5-rem" id="nav-tab" role="tablist">
                <a class="nav-item nav-link nav-link-custom tab-button-product col-4 align-midle" id="lqtajwid-button"
                  data-toggle="tab" href="#collapseLQTajwid" role="tab" aria-controls="collapseLQTajwid" v-scroll-to="{
                                el: '#productContentBGSection',
                                duration: 500,
                                easing: 'linear',
                                offset: -80
                            }" @click="tabClickLQTajwid()"
                  v-bind:class="{ afterclick: isActiveLQTajwid, 'text-danger': hasError }" aria-selected="true">
                  <!-- LQTajwid -->                  
                  <img class="product-img-tab img-tab-tajwid" lazy="loaded">
                </a>
                <a class="nav-item nav-link nav-link-custom tab-button-product col-4" id="lqtafsir-button"
                  href="#collapseLQTafsir" data-toggle="tab" role="tab" aria-controls="collapseLQTafsir" v-scroll-to="{
                                el: '#productContentBGSection',
                                duration: 500,
                                easing: 'linear',
                                offset: -80
                            }" @click="tabClickLQTafsir()"
                  v-bind:class="{ afterclick: isActiveLQTafsir, 'text-danger': hasError }" aria-selected="false">
                  <!-- LQTafsir -->                  
                  <img class="product-img-tab img-tab-tafsir" lazy="loaded">                  
                </a>
                <a class="nav-item nav-link nav-link-custom tab-button-product col-4" id="qtv-button" data-toggle="tab"
                  href="#collapseQTV" role="tab" aria-controls="collapseQTV" v-scroll-to="{
                                el: '#productContentBGSection',
                                duration: 500,
                                easing: 'linear',
                                offset: -80
                            }" @click="tabClickQTV()"
                  v-bind:class="{ afterclick: isActiveQTV, 'text-danger': hasError }" aria-selected="false">
                  <!-- QTV -->                  
                  <img class="product-img-tab img-tab-qtv" lazy="loaded">
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade active show" role="tabpanel" aria-labelledby="collapseLQTajwid"
                id="collapseLQTajwid">
                <!-- moved -->
              </div>
              <div class="tab-pane fade" role="tabpanel" aria-labelledby="collapseLQTafsir" id="collapseLQTafsir">
                <!-- moved -->
              </div>
              <div class="tab-pane fade" role="tabpanel" aria-labelledby="collapseQTV" id="collapseQTV">
                <!-- moved -->
              </div>
            </div>
        </div>
      </div>
      <keep-alive>
        <ProductContentLQTajwid v-if="productAct == 'lqtajwid'" />
        <ProductContentLQTafsir v-else-if="productAct == 'lqtafsir'" />
        <ProductContentQTV v-else />
      </keep-alive>

    </section>
  </div>
</template>

<script>
import ProductContentLQTajwid from './ProductContentLQTajwid.vue';
import ProductContentLQTafsir from './ProductContentLQTafsir.vue';
import ProductContentQTV from './ProductContentQTV.vue';
import LogoLQTafsir from '@/assets/img/tafsir-2.png';

import { createImageObject } from '@/utils/utils';


export default {
  name: 'ProductContentBG' ,
  components: {
    ProductContentLQTajwid,
    ProductContentLQTafsir,
    ProductContentQTV,
},
  data() {
    return {
      // MARK: Change one of the `isActive..` and `defaultTab` variable below to change the default active tab
      defaultTab: 'lqtajwid', // value: 'lqtajwid', 'lqtafsir', 'qtv'
      isActiveLQTajwid: true,
      isActiveLQTafsir: false,
      isActiveQTV: false,
      hasError: false,
      imgObjLogoLQTafsir: createImageObject(LogoLQTafsir),
      theme: 'light',
      prefersDark: window.matchMedia('(prefers-color-scheme: dark)'),      
      isSamsungBrowser: false,
    }
  },
  props: {
      productAct: String
  },
  mounted() {
    this.updateTheme(this.prefersDark.matches)
    this.prefersDark.addEventListener('change', this.handleMediaQueryChange)
    this.$emit('setCurrentActiveProductTab', this.defaultTab);
    this.isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);
    // Force class on body so CSS can act globally
    if (this.isSamsungBrowser) {
      document.body.classList.add('force-dark');
    }
  },
  beforeDestroy() {
    this.prefersDark.removeEventListener('change', this.handleMediaQueryChange)
  },
  computed: {
    
  },   
  methods: {
    tabClickLQTajwid() {      
      this.$emit('setCurrentActiveProductTab', 'lqtajwid');
      this.isActiveLQTajwid = !this.isActiveLQTajwid;            
      if(this.isActiveLQTafsir == true || this.isActiveQTV == true) {
        this.isActiveQTV = false;
        this.isActiveLQTafsir = false;
        // document.getElementById('lqtafsir-button').click();        
      }
    },
    tabClickLQTafsir() {
      this.$emit('setCurrentActiveProductTab', 'lqtafsir');
      this.isActiveLQTafsir = !this.isActiveLQTafsir;
      if(this.isActiveLQTajwid == true || this.isActiveQTV == true) {
        this.isActiveLQTajwid = false;
        this.isActiveQTV = false;
        // document.getElementById('lqtajwid-button').click();        
      }
    },
    tabClickQTV() {
      this.$emit('setCurrentActiveProductTab', 'qtv');
      this.isActiveQTV = !this.isActiveQTV;
      if(this.isActiveLQTafsir == true || this.isActiveLQTajwid == true) {
        this.isActiveLQTajwid = false;
        this.isActiveLQTafsir = false;
        // document.getElementById('lqtajwid-button').click();        
      }
    },
    getDefaultCurrentActiveTab() {
      if (this.isActiveLQTajwid) {
        return 'lqtajwid';
      } else if (this.isActiveLQTafsir) {
        return 'lqtafsir';
      } else if (this.isActiveQTV) {
        return 'qtv';
      } else {
        return 'none'
      }      
    },
    handleMediaQueryChange(e) {
      this.updateTheme(e.matches)
    },
    updateTheme(isDark) {
      this.theme = isDark ? 'dark' : 'light'
      document.body.classList.remove('light', 'dark')
      document.body.classList.add(this.theme)
    }
  },  
}
</script>

<style>
  .carousel-product {
        min-width: 100%!important;
  }
  @media (min-width: 576px) {
    .container {
        max-width: 100%;
    }
  }
  @media (min-width: 1200px) {
    .container {
        max-width: 1140px;
    }
  }
    #productContentBGSection {
      height:100%;
      position: relative;  
    }    

    @media only screen and (max-width: 768px) {
      .img-tab-tajwid[lazy=loaded] {
        content:url("/assets/logos/lqtajwidlogo/logo-lqtajwid-mobile-for-light-mode-min.png");
      }
      .img-tab-tafsir[lazy=loaded] {
        content:url("/assets/logos/lqtafsirlogo/logo-lqtafsir-mobile-for-light-mode-min.png");
      }
      .img-tab-qtv[lazy=loaded] {
        content:url("/assets/logos/qtvlogo/logo-qtv-mobile-dark.png");
      }

      .img-tab-tajwid[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-tafsir[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-qtv[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }

      .product-img-tab {        
        width: 50%;        
        margin-top: 0.2rem;
      }
    }
    
    @media (prefers-color-scheme: dark) and (max-width: 768px){   
      .img-tab-tajwid[lazy=loaded] {
        content: url("/assets/logos/lqtajwidlogo/logo-lqtajwid-mobile-for-dark-mode-min.png");
      }
      .img-tab-tafsir[lazy=loaded] {
        content:url("/assets/logos/lqtafsirlogo/logo-lqtafsir-mobile-for-dark-mode-min.png");
      }
      .img-tab-qtv[lazy=loaded] {
        content:url("/assets/logos/qtvlogo/logo-qtv-mobile-light.png");
      }

      .img-tab-tajwid[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-tafsir[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-qtv[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
    }

    @media only screen and (min-width: 768px) {
      .img-tab-tajwid[lazy=loaded] {
        content:url("/assets/logos/lqtajwidlogo/logo-lqtajwid-desktop-for-light-mode-min.png");
      }
      .img-tab-tafsir[lazy=loaded] {
        content:url("/assets/logos/lqtafsirlogo/logo-lqtafsir-desktop-for-light-mode-min.png");
      }
      .img-tab-qtv[lazy=loaded] {
        content:url("/assets/logos/qtvlogo/logo-qtv-desktop-dark.png");
      }

      .img-tab-tajwid[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-tafsir[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-qtv[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }

      .product-img-tab {
        width:10rem;        
        margin-top: 0.2rem;
      }
    }

    @media (prefers-color-scheme: dark) and (min-width: 768px) {
      .img-tab-tajwid[lazy=loaded] {
        content: url("/assets/logos/lqtajwidlogo/logo-lqtajwid-desktop-for-dark-mode-min.png");
      }
      .img-tab-tafsir[lazy=loaded] {
        content:url("/assets/logos/lqtafsirlogo/logo-lqtafsir-desktop-for-dark-mode-min.png");
      }
      .img-tab-qtv[lazy=loaded] {
        content:url("/assets/logos/qtvlogo/logo-qtv-desktop-light.png");
      }

      .img-tab-tajwid[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-tafsir[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
      .img-tab-qtv[lazy=loading] {
        content:url("/assets/img/loading.gif");
      }
    }

    /* SECTION FOR SAMSUNG DARK MODE .force-dark */
    body.force-dark .img-tab-tajwid[lazy=loaded] {
      content: url("/assets/logos/lqtajwidlogo/logo-lqtajwid-desktop-for-dark-mode-min.png");
    }
    
    @media (max-width: 768px) {
      body.force-dark .img-tab-tajwid[lazy=loaded] {
        content: url("/assets/logos/lqtajwidlogo/logo-lqtajwid-mobile-for-dark-mode-min.png");
      }
      body.force-dark .img-tab-tafsir[lazy=loaded] {
        content:url("/assets/logos/lqtafsirlogo/logo-lqtafsir-mobile-for-dark-mode-min.png");
      }
      body.force-dark .img-tab-qtv[lazy=loaded] {
        content:url("/assets/logos/qtvlogo/logo-qtv-mobile-light.png");
      }
    }

    @media (min-width: 768px) {
      body.force-dark .img-tab-tajwid[lazy=loaded] {
        content: url("/assets/logos/lqtajwidlogo/logo-lqtajwid-desktop-for-dark-mode-min.png");
      }
      body.force-dark .img-tab-tafsir[lazy=loaded] {
        content:url("/assets/logos/lqtafsirlogo/logo-lqtafsir-desktop-for-dark-mode-min.png");
      }
      body.force-dark .img-tab-qtv[lazy=loaded] {
        content:url("/assets/logos/qtvlogo/logo-qtv-desktop-light.png");
      }
    }

    @media (min-width: 992px) {
      .tab-wrapper {
        padding: 0 5rem;
      }
    }

    @media (min-width: 1200px) {
      .tab-wrapper {
        padding: 0 7rem;
      }
    }

    @media (min-width: 1440px) {
      .tab-wrapper {
        padding: 0 10rem;
      }
    }
    /* END SECTION FOR SAMSUNG DARK MODE .force-dark */

    .nav-item:hover {
      /* border-bottom: 1px solid #ff7000;
      opacity: 2; */
    }

    .afterclick {
     opacity: 1!important;
   }

   .nav-item {
    display: flex;
    justify-content: center;
    align-items: center;
   }

   .nav-pills .nav-link {
     /* border-radius: 0; */
   }

   .nav-pills .nav-link-custom {
     border-radius: 0;
   }

   .nav-link-custom {
     border-radius: 0;
     border-bottom: 1px solid #ababab;
     opacity: 0.5;
   }

   .nav-link-custom:hover {
     border-bottom: 1px solid #053448;
      opacity: 1;
   }
   
   .bg-color-dynamic {
    --afterclick-bg-color: white;
    background-color: var(--afterclick-bg-color) !important;  
  }
  
  body.dark .bg-color-dynamic {
    --afterclick-bg-color: #022534 !important;
  }

  body.force-dark .bg-color-dynamic {
    --afterclick-bg-color: #022534 !important;
  }

  .tab-wrapper {
    width: 100%;
  }

</style>
